import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { catchError, finalize } from 'rxjs/operators';
import { RegistrationService } from '../../../../shared/services/auth/registration.service';
import { verifyCodeErrorMessages } from '../../../model/verify-code-error-messages';
import { AnalyticsFormService } from '../../../../core/services/analytics-form.service';
import { ICodeVerificationForm } from '../../../../shared/interfaces/auth.interface';
import { throwError } from 'rxjs';
import { LoaderButtonType } from '../../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-step-phone-verification',
  templateUrl: './step-phone-verification.component.html',
  styleUrls: ['./step-phone-verification.component.scss'],
})
export class StepPhoneVerificationComponent implements OnInit {
  @Input() formGroupName!: string;
  stepForm!: FormGroup;
  submitted = false;
  public formName = 'phoneVerificationGroup';
  public loading = false;
  public sentCode = false;
  public canSend = false;
  public errors: string[];
  public errorMessages = verifyCodeErrorMessages;


  constructor(private formGroupDirective: FormGroupDirective, private registrationService: RegistrationService,
              private analyticsFormService: AnalyticsFormService) {
  }

  ngOnInit(): void {
    this.stepForm = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;

    setTimeout(() => {
      this.canSend = true;
    }, 3000);
  }

  public onSendCodeClick() {
    if (!this.canSend) {
      return;
    }

    this.sentCode = true;
    this.registrationService
      .resendVerificationSms()
      .pipe(
        catchError((errors) => {
          this.errors = errors?.error?.errorCodes;
          this.code.setErrors({ [errors]: true });
          this.analyticsFormService.sendEventForCaughtError('phoneVerificationGroup', this.formName);
          return throwError(() => errors);
        }),
        finalize(() => {
          this.loading = false;
          setTimeout(() => {
            this.sentCode = false;
          }, 10000);
        }),
      ).subscribe();
  }

  onSubmit() {
    this.loading = true;
    if (this.stepForm.invalid) {
      this.submitted = true;
      this.stepForm.markAllAsTouched();
      this.loading = false;
      return;
    }

    const registerData: ICodeVerificationForm = this.stepForm.value;

    this.registrationService
      .verifyPhone(registerData)
      .pipe(
        catchError((errors) => {
          this.errors = errors?.error?.errorCodes;
          this.code.setErrors({ [errors]: true });
          this.analyticsFormService.sendEventForCaughtError('phoneVerificationGroup', this.formName);
          return throwError(() => errors);
        }),
        finalize(() => {
          this.loading = false;
        }),
      ).subscribe();
  }

  get code(): FormControl {
    return this.stepForm.get('code') as FormControl;
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
